import streamSingle from "./stream-single.js";

export default {
	streamSingle,
};
